/* Lịch: loại sự kiện, quyền xem/sửa, gom các mục (hạn việc, sự kiện, hợp đồng hết hạn) lên lịch. Port từ app cũ. */
import { isoAdd } from './dates';
import { CK_KINDS, type ContractLite } from './hr';
import { tkCanEdit, tkInvolved, tkLate, type TaskLite, type TaskUser } from './tasks';

/** [mã, tên, màu] */
export const EV_TYPES: [string, string, string][] = [['meet', 'Họp', 'var(--accent)'], ['deadline', 'Hạn nộp / báo cáo', 'var(--danger)'], ['trip', 'Công tác', 'var(--ok)'], ['leave', 'Nghỉ phép', 'var(--warn)'], ['other', 'Khác', 'var(--muted)']];
export const evType = (k: string | undefined): [string, string, string] => EV_TYPES.find(x => x[0] === k) || EV_TYPES[4];

/** Ngày lễ cố định theo dương lịch (MM-DD). */
export const VN_HOL: Record<string, string> = { '01-01': 'Tết Dương lịch', '04-30': 'Giải phóng miền Nam', '05-01': 'Quốc tế Lao động', '09-02': 'Quốc khánh' };
export const CAL_DOW = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];

/** Sự kiện theo tên trường của app cũ (giao diện ánh xạ từ cột CSDL). */
export interface CalEvent {
  id: string; title: string; type: string; date: string; endDate?: string; allDay?: boolean; start?: string; end?: string; location?: string; note?: string;
  attendeeIds?: string[]; public?: boolean; taskId?: string; createdById?: string; createdBy?: string; createdAt?: string;
}
export interface CalUser extends TaskUser { modules?: string[] }

export const evVisible = (e: Pick<CalEvent, 'public' | 'createdById' | 'attendeeIds'>, me: TaskUser | null): boolean =>
  !me || me.role === 'admin' || !!e.public || e.createdById === me.id || (e.attendeeIds || []).includes(me.id);
export const evCanEdit = (e: Pick<CalEvent, 'createdById'>, me: TaskUser | null): boolean => !me || me.role === 'admin' || e.createdById === me.id;

export interface CalItem {
  kind: 'task' | 'ev' | 'con'; id: string; date: string; time?: string; title: string; sub: string; color: string; done?: boolean; late?: boolean; drag?: boolean;
}
export interface CalShow { task: boolean; ev: boolean; con: boolean }
export interface CalContext {
  tasks: TaskLite[]; events: CalEvent[]; contracts: (ContractLite & { id: string })[]; employees: { id: string; fullName: string; status?: string }[];
  show: CalShow; me: CalUser | null; canLabor: boolean; assigneeName: (t: TaskLite) => string; todayIso: string;
}

/** Tất cả mục hiển thị trên lịch trong khoảng [from, to], xếp theo ngày → giờ → loại. */
export function calItems(from: string, to: string, c: CalContext): CalItem[] {
  const out: CalItem[] = [];
  if (c.show.task) {
    for (const t of c.tasks.filter(x => tkInvolved(x, c.me))) {
      if (!t.due) continue;
      if (t.due < from || t.due > to) continue;
      const late = tkLate(t, c.todayIso);
      out.push({ kind: 'task', id: t.id, date: t.due, title: t.title, sub: c.assigneeName(t), color: t.status === 'done' ? 'var(--ok)' : late ? 'var(--danger)' : t.priority === 'urgent' ? 'var(--danger)' : 'var(--accent)', done: t.status === 'done' || t.status === 'cancel', late, drag: tkCanEdit(t, c.me) });
    }
  }
  if (c.show.ev) {
    for (const e of c.events.filter(x => evVisible(x, c.me))) {
      const end = e.endDate && e.endDate > e.date ? e.endDate : e.date;
      for (let d = e.date > from ? e.date : from; d <= end && d <= to; d = isoAdd(d, 1)) {
        out.push({ kind: 'ev', id: e.id, date: d, time: e.allDay ? '' : e.start || '', title: e.title, sub: [e.location, (e.attendeeIds || []).length ? ((e.attendeeIds as string[]).length + ' người') : ''].filter(Boolean).join(' · '), color: evType(e.type)[2], drag: evCanEdit(e, c.me) && end === e.date });
      }
    }
  }
  if (c.show.con && c.canLabor) {
    for (const k of c.contracts) {
      if (!k.toDate || k.toDate < from || k.toDate > to) continue;
      const e = c.employees.find(x => x.id === k.empId);
      if (!e || (e.status || 'working') === 'left') continue;
      if (c.contracts.some(o => o.empId === k.empId && o.id !== k.id && (o.signDate || '') > (k.signDate || ''))) continue;   // đã có HĐ mới hơn
      out.push({ kind: 'con', id: e.id, date: k.toDate, title: `Hết hạn ${CK_KINDS[k.kind]?.[1] || 'HĐ'}: ${e.fullName}`, sub: k.no || '', color: 'var(--warn)' });
    }
  }
  return out.sort((a, b) => a.date.localeCompare(b.date) || (a.time || '99').localeCompare(b.time || '99') || a.kind.localeCompare(b.kind));
}
